// extracted by mini-css-extract-plugin
export default {"LoaderWrapper":"review_LoaderWrapper__7qhhg","ImageStyle":"review_ImageStyle__eEApo"};